import Content from './UploadDetailsPromptContent';

const Page = () => {
  return <Content />;
};

export default Page;
